import { Box, CameraControls, Clone, Instance, Instances, Merged, PerspectiveCamera, Point, Points } from "@react-three/drei";
import { useDracoGLTF } from "../../../../../utils/useDracoGLTF";
import { useRef, useState } from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { findObjectStartsWithKey } from "../../../../../utils/FindObjects";
import { createPortal, useFrame, useThree } from "@react-three/fiber";
import {
  AdditiveBlending,
  BackSide,
  CatmullRomCurve3,
  Color,
  CurvePath,
  DoubleSide,
  Float32BufferAttribute,
  FrontSide,
  Line,
  LineBasicMaterial,
  LineCurve3,
  MathUtils,
  Mesh,
  MeshBasicMaterial,
  NormalBlending,
  Object3D,
  Quaternion,
  ShaderMaterial,
  Shape,
  TubeGeometry,
  Vector2,
  Vector3,
} from "three";
import { useLayoutEffect } from "react";
import { MeshLineMaterial } from "meshline";
import FresnelMaterial from "../../../materials/FresnelMaterial";
import MagneticFieldMaterial, { MagneticFieldMaterialImpl } from "../../../materials/MagneticFieldMaterial";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
// import CustomShaderMaterial from "three-custom-shader-material";
import CustomShaderMaterial from "three-custom-shader-material/vanilla";

import linesFrag from "./magneticLine_frag.glsl";
import linesVert from "./magneticLine_vert.glsl";
import { mergeBufferGeometries } from "three-stdlib";

import electronShader_frag from "./electrons_frag.glsl";
import electronShader_vert from "./electrons_vert.glsl";
import { useObjectCallback, useSheet } from "../../../../../hooks/useTheatre";
import { ref, useSnapshot } from "valtio";
import store, { cameraStore } from "../../../../../appStore";
import { SideBarHider } from "../../../../ui/SideBar/SideBar";
import { UIPortal } from "@solidwhite/ui-portal";
import { useTranslation } from "react-i18next";
import { MountWithEbbne } from "@solidwhite/ebbnen";
import { useSpring, animated as a, config } from "@react-spring/web";
import { Slider } from "@mui/material";
import { useMultiuserContext, useSynchronizedState } from "@solidwhite/multiuser";
import { throttle } from "lodash";
import CarrierSequenceSynchrnoizer from "./CarrierSequenceSynchrnoizer";

const animationConfig = {
  animationTime: 0,
  carrierCurveValue: 0,
  magneticField: 0,
  electroLine_01: 0,
  electroLine_2: 0,
  controlCam: false,
  animationSection: 0,
};

const carrierAnimworldPos = new Vector3();
const carrietTangent = new Vector3();

let smoothedAnimationTime = 0;
let sequenceTime = 0;
let runningForward = true;
let currentAnimationSection = 0;
let animationSpeed = 1;
let targetAnimationSpeed = 1;

const CarrierMovementAnimation = ({ nodes, actions }) => {
  const set = useThree(({ set }) => set);
  const camera = useThree(({ camera }) => camera);
  const cameraRef = useRef();

  const { connected, presenting, spectating, broadcastMessage } = useMultiuserContext();

  const [slowMo, setSlowMo] = useState(false);
  const [animationSpeedState, setanimationSpeedState] = useState(1);

  const carrierSplineValue = useRef(0);

  const controlCamera = useRef(false);
  const [controlCameraState, setcontrolCameraState] = useState(false);

  const { cameraControlsRef } = useSnapshot(cameraStore);

  const magneticHullRef = useRef();
  const magneticLinesRef = useRef();
  const electoroLinesRef = useRef();

  const carrierWorldPosition = useMemo(() => {
    return new Vector3();
  }, []);

  const camWorldPosition = useMemo(() => {
    return new Vector3();
  }, []);
  const camTargetWorldPosition = useMemo(() => {
    return new Vector3();
  }, []);

  const action = useMemo(() => {
    return Object.values(actions)[0];
  }, [actions]);

  const trackCurve = useMemo(() => {
    const positionsAttributeArray = nodes.Spline_carrier_mesh.geometry.getAttribute("position");

    const points = [];

    for (let index = 0; index < positionsAttributeArray.count; index += 1) {
      points.push(
        new Vector3(
          positionsAttributeArray.getX(index),
          positionsAttributeArray.getY(index),
          positionsAttributeArray.getZ(index),
        ),
      );
    }

    points.forEach((p) => p.applyMatrix4(nodes.Spline_Track.matrix).applyMatrix4(nodes.Spline_carrier.matrix));

    const curve = new CatmullRomCurve3(points);

    return curve;
  }, []);

  const setCarrierPositionOnCurve = (t) => {
    // carrierSplineValue.current = t;
    if (trackCurve) {
      trackCurve.getPoint(t, nodes.Carrier_root.position);
      trackCurve.getTangent(t, carrietTangent);

      nodes.Carrier_root.getWorldPosition(carrierAnimworldPos);
      carrierAnimworldPos.sub(carrietTangent);
      nodes.Carrier_root.lookAt(carrierAnimworldPos);
      // console.log();
      // nodes.Carrier_root.position.copy(trackCurve.getPointAt(t));
      // nodes.Carrier_root.
    }
  };

  useEffect(() => {
    sequenceTime = 0;
    action.reset().play();
    action.play();
    action.paused = true;
    sheet.sequence.position = 0;
    // sheet.sequence.play({
    //   iterationCount: Infinity,
    //   direction: "alternate",
    //   rate: 1,
    // });
    return () => {
      sheet.sequence.position = 0;
      sheet.sequence.pause();
      action.time = 0;
      action.stop().reset();
      setCarrierPositionOnCurve(0);
      smoothedAnimationTime = 0;
    };
  }, []);

  // useEffect(() => {
  //   console.log(slowMo);
  //   if (slowMo) {
  //     targetAnimationSpeed = 0.15;
  //   } else {
  //     targetAnimationSpeed = 1;
  //   }
  // }, [slowMo]);

  useEffect(() => {
    targetAnimationSpeed = animationSpeedState;
  }, [animationSpeedState]);

  useEffect(() => {
    cameraStore.cameraTargetSettings = ref(camTarget);

    camTarget.getWorldPosition(camTargetWorldPosition);
    camRotationTarget.getWorldPosition(camWorldPosition);
  }, []);

  const [camTarget, camRotationTarget] = useMemo(() => {
    return [nodes.camtarget_movement_anim, nodes.camdist_movement_anim];
  }, []);

  useLayoutEffect(() => {
    cameraControlsRef.setBoundary(undefined);

    return () => {
      cameraControlsRef.smoothTime = 0.35;
    };
  }, []);

  useEffect(() => {
    if (controlCameraState) {
      cameraControlsRef.smoothTime = 0.05;
    } else {
      cameraControlsRef.smoothTime = 0.35;
    }
  }, [controlCameraState]);

  const throttledSend = useMemo(() => {
    return throttle((value) => {
      broadcastMessage("car_seq", sheet.sequence.position);
    }, 33);
  }, []);

  const updateAnimation = () => {
    if (magneticHullRef.current) {
      smoothedAnimationTime += (carrierSplineValue.current - smoothedAnimationTime) * 0.05;
      setCarrierPositionOnCurve(smoothedAnimationTime);

      nodes.Carrier_root.getWorldPosition(carrierWorldPosition);
      magneticHullRef.current.setCarrierPosition(carrierWorldPosition);
      magneticLinesRef.current.setCarrierPosition(carrierWorldPosition);
      electoroLinesRef.current.setCarrierPosition(carrierWorldPosition);

      // cameraControlsRef.setTarget(
      //   carrierWorldPosition.x,
      //   carrierWorldPosition.y,
      //   carrierWorldPosition.z,
      //   false
      // );

      if (controlCamera.current) {
        camTarget.getWorldPosition(camTargetWorldPosition);
        camRotationTarget.getWorldPosition(camWorldPosition);

        cameraControlsRef.setLookAt(
          camWorldPosition.x,
          camWorldPosition.y,
          camWorldPosition.z,
          camTargetWorldPosition.x,
          camTargetWorldPosition.y,
          camTargetWorldPosition.z,
          false,
        );
      }
    }
  };

  useFrame(({ clock }, delta) => {
    if (connected && spectating) {
      updateAnimation();
      return;
    }

    animationSpeed += (targetAnimationSpeed - animationSpeed) * 0.5;

    if (runningForward) {
      sequenceTime += delta * animationSpeed;
    } else {
      sequenceTime -= delta * animationSpeed;
    }

    sheet.sequence.position = sequenceTime;

    if (connected && presenting) {
      throttledSend();
    }

    updateAnimation();
  }, 3);

  const sheet = useSheet("EFD", "POWERRAL_CARRIER", "0");

  useObjectCallback(
    sheet,
    "Animation",
    animationConfig,
    ({ animationTime, magneticField, electroLine_01, electroLine_2, controlCam, carrierCurveValue, animationSection }) => {
      action.time = animationTime;
      // setCarrierPositionOnCurve(carrierCurveValue);
      carrierSplineValue.current = carrierCurveValue;

      if (electoroLinesRef.current) {
        electoroLinesRef.current.setLineOpacity0(electroLine_01);
        electoroLinesRef.current.setLineOpacity1(electroLine_01);
        electoroLinesRef.current.setLineOpacity2(electroLine_2);
      }

      if (magneticLinesRef.current) {
        magneticLinesRef.current.setLineOpacity(magneticField);
      }
      if (magneticHullRef.current) {
        magneticHullRef.current.setLineOpacity(magneticField);
      }
      if (controlCam != controlCamera.current) {
        setcontrolCameraState(controlCam);
      }
      controlCamera.current = controlCam;

      if (Math.floor(animationSection) != currentAnimationSection) {
        currentAnimationSection = Math.floor(animationSection);
        if (currentAnimationSection == 2) runningForward = false;
        else if (currentAnimationSection == 0) runningForward = true;
      }
    },
  );

  // console.log(cameraControlsRef);

  return (
    <>
      <MagneticHull ref={magneticHullRef} />
      <MagneticLines nodes={nodes} ref={magneticLinesRef} />

      <ElectorLines nodes={nodes} ref={electoroLinesRef} />

      {/* <CameraControls makeDefault /> */}

      <SideBarHider />

      <MountWithEbbne>
        <UIPortal>
          {/* <SlowmoMenu
            setSlowMo={setSlowMo}
            slowmo={slowMo}
            key="capacitor-slowmo-menuu"
          /> */}
          <SpeedSlider setSpeed={setanimationSpeedState} key="capacitor-slowmo-menu" />
        </UIPortal>
      </MountWithEbbne>

      {spectating && connected && <CarrierSequenceSynchrnoizer sequence={sheet.sequence} />}

      {/* {createPortal(
        <group>
          <group rotation={[0, MathUtils.degToRad(180), 0]}>
            <PerspectiveCamera makeDefault={false} fov={60} ref={cameraRef} />
          </group>
        </group>,
        nodes.MovementCam_2
      )} */}
    </>
  );
};

const linesWidth = 0.2;
const linesCount = 450;

const MagneticLines = forwardRef(({ nodes }, ref) => {
  const matRef = useRef();

  const trackCurve = useMemo(() => {
    const positionsAttributeArray = nodes.Spline_Track.geometry.getAttribute("position");

    const points = [];

    for (let index = 0; index < positionsAttributeArray.count; index += 1) {
      points.push(
        new Vector3(
          positionsAttributeArray.getX(index),
          positionsAttributeArray.getY(index),
          positionsAttributeArray.getZ(index),
        ),
      );
    }

    const curve = new CatmullRomCurve3(points);

    return curve;
  }, []);

  const [tubeGeo, tubeGeometries, points] = useMemo(() => {
    // let points = [];

    // let positionsAttributeArray =
    //   nodes.Spline_MagneticField_0.geometry.attributes.position.array;

    // for (let index = 0; index < positionsAttributeArray.length; index += 3) {
    //   points.push(
    //     new Vector3(
    //       positionsAttributeArray[index],
    //       positionsAttributeArray[index + 1],
    //       positionsAttributeArray[index + 2]
    //     )
    //   );
    //   // const element = array[index];
    // }

    // const curve = new CatmullRomCurve3(points);

    // // const geo = new TubeGeometry(curve, 64, 0.0005, 3);

    var positionsAttributeArray = nodes.Spline_MagneticField_1.geometry.getAttribute("position");
    // nodes.Spline_MagneticField_1.geometry.attributes.position.array;

    var points = [];

    for (let index = 0; index < positionsAttributeArray.count; index += 1) {
      points.push(
        new Vector3(
          positionsAttributeArray.getX(index),
          positionsAttributeArray.getY(index),
          positionsAttributeArray.getZ(index),
        ),
      );
    }

    const curve1 = new CatmullRomCurve3(points);

    const geo1 = new TubeGeometry(curve1, 16, 0.00085, 2);

    let allGeos = [];

    for (let index = 0; index < linesCount; index++) {
      const t = index / linesCount;
      const pos = trackCurve.getPoint(t);
      const tangent = trackCurve.getTangent(t).normalize();

      const forward = new Vector3(-1, 0, 0);
      const angle = forward.angleTo(tangent);

      let nGeo = geo1.clone();

      nGeo.rotateY(angle);
      nGeo.translate(pos.x, pos.y, pos.z);
      allGeos.push(nGeo);
    }

    const merged = mergeBufferGeometries(allGeos);

    return [geo1, merged, points];
  }, []);

  const LineMaterial = useMemo(() => {
    // new CSM()
    const material = new CustomShaderMaterial({
      baseMaterial: MeshBasicMaterial,
      vertexShader: linesVert,
      fragmentShader: linesFrag,
      silent: true, // Disables the default warning if true
      uniforms: {
        uCarrierPosition: {
          value: new Vector3(),
        },
      },
      transparent: true,
      depthTest: false,
      opacity: 1.4,
      color: "#68acfa",
      blending: NormalBlending,
    });

    return material;
  }, []);

  useImperativeHandle(ref, () => ({
    setCarrierPosition: (v) => {
      if (matRef.current) {
        matRef.current.uniforms.uCarrierPosition.value.copy(v);
      }
      LineMaterial.uniforms.uCarrierPosition.value.copy(v);
    },
    setLineOpacity: (v) => {
      LineMaterial.opacity = v * 1.4;
    },
  }));

  return (
    <group>
      {createPortal(
        <group visible={true}>
          <group position={[0, -0.005, 0]} scale={new Vector3(1, 1, 1)} rotation={[0, 0, 0]} visible={true}>
            <group
              position={[0, -0.015, -0.08]}
              // rotation={[0, MathUtils.degToRad(180), 0]}
              visible={true}
            >
              <mesh geometry={tubeGeometries} material={LineMaterial} visible={true}></mesh>
            </group>
            <group
              position={[0, -0.79, -0.08]}
              scale={[1, -1, 1]}

              // rotation={[0, MathUtils.degToRad(180), 0]}
            >
              <mesh geometry={tubeGeometries} material={LineMaterial}></mesh>
            </group>
          </group>
        </group>,
        nodes.Spline,
      )}
    </group>
  );
});

const MagneticHull = forwardRef(({}, ref) => {
  const { nodes } = useDracoGLTF("./models/charge/powerrail_shapes.glb");

  useImperativeHandle(ref, () => ({
    setCarrierPosition: (v) => {
      material.uniforms.uCarrierPosition.value.copy(v);
    },
    setLineOpacity: (v) => {
      material.opacity = v * 1.5;
    },
  }));

  const material = useMemo(() => {
    var mat = new MagneticFieldMaterialImpl();
    // mat.uniforms.uFresnelColor.value = new Color("#013c80")
    mat.uniforms = {
      ...mat.uniforms,
      uFresnelColor: { value: new Color("#013c80") },
      uBaseColor: { value: new Color("#ffa600") },
      uFresnelPower: { value: 0.2 },
    };
    mat.side = DoubleSide;
    mat.opacity = 1.5;
    mat.blending = AdditiveBlending;
    mat.transparent = true;
    mat.depthWrite = false;
    mat.depthTest = false;
    return mat;
  }, []);

  useFrame(({ clock }) => {
    material.uniforms.uTime.value = clock.elapsedTime;
  }, []);

  return (
    <group visible={true}>
      <group position={[0, 0.001, 0]}>
        <mesh
          geometry={nodes.powerrail_shapes.geometry}
          position={nodes.powerrail_shapes.position}
          rotation={nodes.powerrail_shapes.rotation}
          scale={nodes.powerrail_shapes.scale}
          material={material}
          renderOrder={-1}
        ></mesh>
      </group>
      <group position={[0, 0.0075, 0]}>
        <group position={nodes.powerrail_shapes.position} scale={[1, -1, 1]}>
          <mesh
            geometry={nodes.powerrail_shapes.geometry}
            rotation={nodes.powerrail_shapes.rotation}
            scale={nodes.powerrail_shapes.scale}
            renderOrder={-1}
            material={material}
          ></mesh>
        </group>
      </group>
    </group>
  );
});

const ElectorLines = forwardRef(({ nodes }, ref) => {
  const [material0, material1, material2] = useMemo(() => {
    const material = new ShaderMaterial({
      fragmentShader: electronShader_frag,
      vertexShader: electronShader_vert,
      // vertexColors: true,
      transparent: true,
      depthWrite: false,
      depthTest: false,
      side: DoubleSide,
      // blending: AdditiveBlending,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 1,
        },
        uBaseColor: {
          value: new Color("#e5ff00"),
        },
        uBaseColorPower: {
          value: 1,
        },
        uSize: {
          value: 0.02,
        },
        uStep: {
          value: 0.95,
        },
        uStepRange: {
          value: 0.05,
        },
        uDirection: {
          value: 4,
        },
        uOpacity: {
          value: 0.185,
        },
        uCarrierPosition: {
          value: new Vector3(),
        },
      },
    });

    const material2 = material.clone();
    material2.uniforms.uDirection.value = -4;

    const material3 = new ShaderMaterial({
      fragmentShader: electronShader_frag,
      vertexShader: electronShader_vert,
      // vertexColors: true,
      transparent: true,
      depthWrite: false,
      depthTest: false,
      side: DoubleSide,
      // blending: AdditiveBlending,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 1,
        },
        uBaseColor: {
          value: new Color("#68acfa"),
        },
        uBaseColorPower: {
          value: 2,
        },
        uSize: {
          value: 0.1,
        },
        uStep: {
          value: 0.9,
        },
        uStepRange: {
          value: 0.2,
        },
        uDirection: {
          value: 0.25,
        },
        uOpacity: {
          value: 0.185,
        },
        uCarrierPosition: {
          value: new Vector3(),
        },
      },
    });

    return [material, material2, material3];
  }, []);

  const sine = useRef(0);
  const sineTime = useRef(0);
  const animationSpeed = 1;

  useFrame(({ clock }) => {
    sine.current = Math.sin(clock.elapsedTime * animationSpeed);
    sineTime.current += sine.current * 0.0015;

    material0.uniforms.uTime.value = sineTime.current;
    material1.uniforms.uTime.value = sineTime.current;
    material2.uniforms.uTime.value = clock.elapsedTime;
  });

  useImperativeHandle(ref, () => ({
    setLineOpacity0: (v) => {
      material0.uniforms.uOpacity.value = v;
    },
    setLineOpacity1: (v) => {
      material1.uniforms.uOpacity.value = v;
    },
    setLineOpacity2: (v) => {
      material2.uniforms.uOpacity.value = v;
    },
    setCarrierPosition: (v) => {
      material0.uniforms.uCarrierPosition.value.copy(v);
      material1.uniforms.uCarrierPosition.value.copy(v);
      material2.uniforms.uCarrierPosition.value.copy(v);
    },
  }));

  return (
    <>
      <mesh
        geometry={nodes.Spline_electro_0.geometry}
        position={nodes.Spline_electro_0.position}
        rotation={nodes.Spline_electro_0.rotation}
        material={material0}
      >
        {/* <meshBasicMaterial wireframe transparent depthTest={false} /> */}
      </mesh>
      <mesh
        geometry={nodes.Spline_electro_1.geometry}
        position={nodes.Spline_electro_1.position}
        rotation={nodes.Spline_electro_1.rotation}
        material={material1}
      />
      {createPortal(
        <mesh
          geometry={nodes.Spline_electro_2.geometry}
          position={nodes.Spline_electro_2.position}
          rotation={nodes.Spline_electro_2.rotation}
          material={material2}
        />,
        nodes.Carrier_root,
      )}
    </>
  );
});

const SlowmoMenu = ({ slowmo = false, setSlowMo = (slow) => {}, visible = false }) => {
  const { opacity } = useSpring({
    opacity: visible ? 1 : 0,
    config: config.default,
  });

  return (
    <a.div
      style={{
        position: "absolute",
        bottom: "0px",
        width: "100%",
        height: "6vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: opacity,
      }}
    >
      <div
        style={{
          width: "20vw",
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <SlowmoButton onClick={() => setSlowMo(false)} active={!slowmo}>
          L6_CHARGE_PRODUCTS_POWERRAIL_MOVEMENT_FAST
        </SlowmoButton>
        <SlowmoButton onClick={() => setSlowMo(true)} active={slowmo}>
          L6_CHARGE_PRODUCTS_POWERRAIL_MOVEMENT_SLOW
        </SlowmoButton>
      </div>
    </a.div>
  );
};

const SlowmoButton = ({ onClick = () => {}, active = false, children }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        color: active ? "#fff" : "#000",
        textAlign: "center",
        width: "max-content",
        minWidth: "5vw",
        height: "1vw",
        fontSize: "0.9vw",
        fontWeight: 500,
        padding: "0.75vw",
        paddingLeft: "0.75vw",
        paddingTop: "0.5vw",
        paddingBottom: "0.5vw",
        pointerEvents: "auto",
        transition: "0.2s linear",
        borderRadius: "3px",
        border: active ? "2px solid #fff" : "2px solid #1b5739",
        cursor: active ? "auto" : "pointer",
        opacity: 1,
        backgroundColor: active ? "#37a46e" : "#1b5739",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      {t(children)}
    </div>
  );
};

const SpeedSlider = ({ setSpeed = (speed) => {}, visible = false }) => {
  const { opacity } = useSpring({
    opacity: visible ? 1 : 0,
    config: config.default,
  });

  const [value, setValue] = useSynchronizedState("speedslider", 1);

  const handleChange = (e) => {
    setSpeed(e.target.value);
    setValue(e.target.value);
    // console.log(e.target.value);
  };

  return (
    <a.div
      style={{
        position: "absolute",
        bottom: "0px",
        width: "100%",
        height: "7vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: opacity,
      }}
    >
      <div
        style={{
          width: "20vw",
          height: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "1.5vw",
          paddingLeft: "2vw",
          paddingRight: "2vw",
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Slider
          onChange={handleChange}
          style={{ pointerEvents: "auto", color: "#37a46e" }}
          min={0.1}
          max={3}
          defaultValue={1}
          step={0.02}
          value={value}
        />
      </div>
    </a.div>
  );
};

export default CarrierMovementAnimation;
